import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card } from 'antd';
import CertificateCard from '../components/CertificateCard';
import PageHeader from 'components/Common/PageHeader';

const DocumentView: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className='page-wrapper'>
      <div className="content">
        <PageHeader title={t('document.myDocuments')} breadcrumbItems={[
          { label: "dashboard", path: "/dashboard" },
          { label: "document.label", active: true }
        ]} />
        <Card>
          <CertificateCard t={t} />
        </Card>
      </div>
    </div>
  );
};

export default DocumentView;
